import React from 'react';
import { Link } from 'react-router-dom';
interface WorkMirrorStartModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function WorkMirrorStartModal({
  isOpen,
  onClose
}: WorkMirrorStartModalProps) {
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-238" />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 overflow-y-auto" data-id="element-239">
        <div className="relative bg-[#0A0A0A] border border-[#2B2B2B] w-full max-w-2xl max-h-[90vh] overflow-y-auto my-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" onClick={e => e.stopPropagation()} data-id="element-240">
          {/* Close button */}
          <button onClick={onClose} className="absolute top-4 right-4 sm:top-6 sm:right-6 text-gray-600 hover:text-[#F5F5F5] transition-colors z-10" aria-label="Close" data-id="element-241">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-242">
              <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-243" />
            </svg>
          </button>

          {/* Content */}
          <div className="p-6 sm:p-8 md:p-12 space-y-8 sm:space-y-10" data-id="element-244">
            {/* Title */}
            <div className="space-y-3 sm:space-y-4 pr-8" data-id="element-245">
              <h2 id="modal-title" className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#F5F5F5] leading-tight" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-246">
                Set up your Work Mirror
              </h2>
              <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-247">
                Work Mirror builds a living model of how you operate at work.
                This starts with a short calibration.
              </p>
            </div>

            {/* Body copy */}
            <div className="space-y-4 sm:space-y-6 text-sm sm:text-base text-gray-400 leading-relaxed border-l-2 border-[#2B2B2B] pl-4 sm:pl-6" data-id="element-248">
              <p data-id="element-249">
                This is not a test.
                <br data-id="element-250" />
                This is not a personality profile.
                <br data-id="element-251" />
                And this is not a diagnosis.
              </p>

              <p className="text-[#F5F5F5]" data-id="element-252">
                This is the first compile of a system model.
              </p>

              <p data-id="element-253">
                You'll answer a few structural questions. The Mirror will use
                this to create an initial, low-confidence model of your work
                pattern.
              </p>

              <p data-id="element-254">
                The model will refine itself as you log real situations, states,
                and decisions.
              </p>
            </div>

            {/* Time expectation */}
            <div className="pt-4 sm:pt-6 border-t border-[#2B2B2B]" data-id="element-255">
              <p className="text-xs sm:text-sm text-gray-600" data-id="element-256">
                Takes about 2–3 minutes.
              </p>
            </div>

            {/* Actions */}
            <div className="space-y-3 sm:space-y-4" data-id="element-257">
              <Link to="/mirrors/work/begin" className="block w-full px-6 sm:px-8 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-center text-sm font-medium tracking-widest uppercase hover:bg-gray-200 transition-colors" data-id="element-258">
                Start calibration
              </Link>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm" data-id="element-259">
                <button onClick={onClose} className="text-gray-600 hover:text-gray-400 transition-colors" data-id="element-260">
                  Not now
                </button>

                <Link to="/decoder" className="text-gray-600 hover:text-gray-400 transition-colors" data-id="element-261">
                  How does this work?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}